import React from "react";
import { Switch, Route } from "react-router";
import { BrowserRouter as Router } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import Nav from "./nav";
import MoreInfo from "./more";
import Search from "./search";
import home from "./home";

import "../App.css";
function App() {
  return (
    <Router>
      <Nav />
      <Switch>
        <Route path="/" exact component={home} />
        <Route path="/search" exact component={Search} />
        <Route path="/shop/:id" component={MoreInfo} />
      </Switch>
    </Router>
  );
}

export default App;
